import type { ReactNode } from "react";
import useQuestionResponse from "./useQuestionResponse";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader } from "frontend-components";

function QuestionHeader({ children }: { children?: ReactNode }) {
    const { question, questionIndex } = useQuestionResponse();
    return (
        <CardHeader className="flex flex-row items-center justify-between pb-2">
            <h2>
                {questionIndex}. {question.questionText}
            </h2>
            {children}
        </CardHeader>
    );
}

function QuestionContent({ children }: { children: ReactNode }) {
    const { t } = useTranslation();
    const { answers } = useQuestionResponse();
    return (
        <CardContent className="min-h-0 flex-1 overflow-y-auto">
            {answers.length > 0 ? (
                children
            ) : (
                <div className="text-sm text-center">{t("responseOverview.noAnswers")}</div>
            )}
        </CardContent>
    );
}

function QuestionResponse({ children }: { children?: ReactNode }) {
    return <Card className="w-full shadow-sm">{children}</Card>;
}

function ResponseLayout({ children }: { children?: ReactNode }) {
    return (
        <div className="space-x-4 w-full flex flex-col lg:flex-row lg:max-h-96 lg:min-h-40">
            {children}
        </div>
    );
}

export { QuestionResponse, ResponseLayout, QuestionHeader, QuestionContent };
